<template>

  <GestisciSolleciti />
 
</template>

<script>
import GestisciSolleciti from '../components/pratiche/GestisciSolleciti.vue'

export default {
  components: {
    GestisciSolleciti
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

